export default __webpack_public_path__ + "static/media/home-website.15e6d618.svg";